import api from "./client";

export async function fetchCertificates() {
  const { data } = await api.get("/api/certificate");
  return data.data ?? data;
}

export async function insertCertificate(payload) {
  const { data } = await api.post("/api/certificate", payload);
  return data;
}

export async function updateCertificate(id, payload) {
  const { data } = await api.put(`/api/certificate/${id}`, payload);
  return data;
}

export async function deleteCertificate(id) {
  await api.delete(`/api/certificate/${id}`);
}

export async function fetchCertificateCategories() {
  const { data } = await api.get("/api/certificate/categories");
  return data;
}

export async function toggleCertificateFeatured(id) {
  const { data } = await api.patch(`/api/certificate/${id}/featured`);
  return data;
}
